export default __webpack_public_path__ + "static/media/BB_25.70a95eae.png";